// @flow
import * as React from 'react'
import type { InputType } from 'types/input-field'
import Grid from 'ui/atoms/Grid'
import Heading from 'ui/atoms/Heading'
import Space from 'ui/atoms/Space'

import InputTypeButton from './InputTypeButton'

const questionTypes: Array<{ label: string, value: InputType }> = [
  { label: 'Full Name', value: 'full_name' },
  { label: 'Text', value: 'text' },
  { label: 'Checkbox', value: 'checkbox' },
  { label: 'Date', value: 'date' },
  { label: 'Signature', value: 'signature' },
  { label: 'Initials', value: 'initials' },
]

function AddInputPanel(): React.Node {
  return (
    <Space size="large">
      <Heading>Add field</Heading>
      <Grid cols={1} gap="small">
        {questionTypes.map((type) => (
          <InputTypeButton
            key={type.value}
            label={type.label}
            value={type.value}
          />
        ))}
      </Grid>
    </Space>
  )
}

export default AddInputPanel
